var _a;
import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { MediaBreakPointUp, Colors } from '../styles';
import { ArrowDirection, ArrowIcon, Button, ButtonType, CautionIcon } from '../atoms';
import { Link } from 'react-router-dom';
import { routes } from '@lean-body/src/route';
import { SettingItemKeys } from './setting_menu';
import { MovieIcon } from '../atoms/icons/movie_icon';
export var UnsubscribeWarning = function (props) {
    var className = props.className, payment = props.payment, profile = props.profile;
    var containerClass = [className || '', css(styles.container)].join(' ');
    var name = profile.userName && "".concat(profile.userName, "\u3055\u3093\u306F");
    return (React.createElement("div", { className: containerClass },
        React.createElement(CautionIcon, { classObject: styles.icon }),
        React.createElement("div", { className: css(styles.description) },
            name,
            "\u4ECA\u9000\u4F1A\u3092\u624B\u7D9A\u304D\u3092\u3057\u3066\u3082\u3042\u3068",
            React.createElement("span", { className: css(styles.descriptionAccent) }, payment.periodEndDiffFromNow()),
            "\u65E5\u3001\u6B21\u306E\u66F4\u65B0\u65E5\u307E\u3067LEAN BODY\u3092\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u3002"),
        React.createElement("div", { className: css(styles.warn) }, "\u203B\u9000\u4F1A\u3059\u308B\u3068\u3001\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u308B\u30B5\u30FC\u30D3\u30B9\u306B\u5F71\u97FF\u304C\u3042\u308A\u307E\u3059\u3002"),
        React.createElement("div", { className: css(styles.chatbotLocation) }, "\u9000\u4F1A\u624B\u7D9A\u304D\u306F\u300C\u9000\u4F1A\u306E\u304A\u624B\u7D9A\u304D\u306F\u3053\u3061\u3089\u304B\u3089\u300D\u306E\u30DC\u30BF\u30F3\u304B\u3089\u884C\u3048\u307E\u3059\u3002"),
        React.createElement("div", { className: css(styles.rerunVideoTitle) }, "\uFF3C\u9000\u4F1A\u624B\u7D9A\u304D\u306E\u524D\u306B\uFF01\uFF0F"),
        React.createElement(Link, { to: routes.SEARCH.compile() },
            React.createElement(Button, { className: css(styles.returnVideoButton), fullWidth: true, buttonType: ButtonType.primary },
                React.createElement(MovieIcon, { classObject: styles.movieIcon }),
                "\u898B\u9003\u3057\u3066\u3044\u308B\u52D5\u753B\u3092",
                React.createElement("br", null),
                "\u30C1\u30A7\u30C3\u30AF\u3059\u308B")),
        React.createElement(Link, { className: css(styles.checkPlan), to: "".concat(routes.SETTING.compile(), "?key=").concat(SettingItemKeys.plan) },
            "\u767B\u9332\u4E2D\u306E\u30D7\u30E9\u30F3\u3068\u66F4\u65B0\u65E5\u3092\u78BA\u8A8D\u3059\u308B",
            React.createElement(ArrowIcon, { classObject: styles.checkPlanArrow, color: Colors.Black, direction: ArrowDirection.right }))));
};
var styles = StyleSheet.create({
    container: {},
    icon: {
        width: 37,
        height: 35,
        margin: '0 auto 20px',
        display: 'block',
    },
    description: {
        color: Colors.Black,
        fontWeight: 500,
        lineHeight: '160%',
        letterSpacing: '1.28px',
    },
    descriptionAccent: {
        fontWeight: 'bold',
        color: Colors.Accent,
    },
    warn: {
        color: Colors.Accent,
        fontSize: 14,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: '0.56px',
        margin: '20px 0',
    },
    chatbotLocation: {
        color: Colors.Black,
        fontSize: 14,
        lineHeight: '160%',
        letterSpacing: '1.28px',
    },
    rerunVideoTitle: {
        fontSize: 12,
        fontWeight: 'bold',
        lineHeight: '160%',
        letterSpacing: '0.48px',
        color: Colors.PrimaryDarkB,
        textAlign: 'center',
        marginTop: 40,
        marginBottom: 4,
    },
    returnVideoButton: (_a = {
            fontSize: 14,
            fontWeight: 'bold',
            lineHeight: '140%',
            letterSpacing: '0.56px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '8px 0'
        },
        _a[MediaBreakPointUp.MD] = {
            width: 315,
            margin: '0 auto',
        },
        _a),
    movieIcon: {
        marginRight: 10,
    },
    checkPlan: {
        color: Colors.Black,
        fontSize: 12,
        fontWeight: 'bold',
        marginTop: 45,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    checkPlanArrow: {
        height: 8,
    },
});
